import {useTransactionInitializationStore} from "../../stores/useTransactionInitializationStore";
import {useCallback} from "react";
import {LookupItemModel} from "../../../../../models";

export const useTransactionInitializationActions = () => {
    const {
        setBeneficiaryList,
        setOriginalBeneficiaryList,
        setCategoryList,
        setItemList,
        setItemsPerCategoryList,
        setPaymentTypeList,
        setCurrencyList,
        setStoreEmployeeList,
        setCostCenterList,
        setCalcTypeList,
        setStoreList,
        setLoading,
        setIsLoaded,
        setIsSalesComponent,
        setHasSingleStore,
        setDefaultStoreId,
        resetState
    } = useTransactionInitializationStore();
    const handleSetBeneficiaryList = useCallback(
        (list: LookupItemModel[]) => {
            setBeneficiaryList(list);
        },
        [setBeneficiaryList]
    );
    const handleSetOriginalBeneficiaryList = useCallback(
        (list: LookupItemModel[]) => {
            setOriginalBeneficiaryList(list);
        },
        [setOriginalBeneficiaryList]
    );
    const handleSetCategoryList = useCallback(
        (list: LookupItemModel[]) => {
            setCategoryList(list);
        },
        [setCategoryList]
    );
    const handleSetItemList = useCallback(
        (list: LookupItemModel[]) => {
            setItemList(list);
        },
        [setItemList]
    );
    const handleSetItemsPerCategoryList = useCallback(
        (list: LookupItemModel[]) => {
            setItemsPerCategoryList(list);
        },[setItemsPerCategoryList]
    );
    const handleSetPaymentTypeList = useCallback(
        (list: LookupItemModel[]) => {
            setPaymentTypeList(list);
        },
        [setPaymentTypeList]
    );
    const handleSetCurrencyList= useCallback(
        (list: LookupItemModel[]) => {
            setCurrencyList(list);
        },
        [setCurrencyList]
    );
    const handleSetStoreEmployeeList = useCallback(
        (list: LookupItemModel[]) => {
            setStoreEmployeeList(list);
        },
        [setStoreEmployeeList]
    );
    const handleSetCostCenterList = useCallback(
        (list: LookupItemModel[]) => {
            setCostCenterList(list);
        },[setCostCenterList]
    )
    const handleSetCalcTypeList = useCallback(
        (list: LookupItemModel[]) => {
            setCalcTypeList(list);
        },
        [setCalcTypeList]
    );
    const handleSetStoreList = useCallback(
        (list: LookupItemModel[]) => {
            setStoreList(list);
        },
        [setStoreList]
    )
    const handleSetLoading = useCallback(
        (load: boolean) => {
            setLoading(load);
        },
        [setLoading]
    );
    const handleSetIsLoaded = useCallback(
        (isLoaded: boolean) => {
            setIsLoaded(isLoaded);
        },
        [setIsLoaded]
    );
    const handleSetIsSalesComponent = useCallback(
        (isSalesComponent: boolean) => {
            setIsSalesComponent(isSalesComponent);
        }, [setIsSalesComponent]
    )
    const handleSetHasSingleStore = useCallback(
        (hasSingleStore: boolean) => {
            setHasSingleStore(hasSingleStore);
        },
        [setHasSingleStore]
    )
    const handleSetDefaultStoreId = useCallback(
        (storeId: number) => {
            setDefaultStoreId(storeId);
        },[setDefaultStoreId]
    )
    const handleResetState = useCallback(() => {
        resetState();
    }, [resetState]);

    return {
        handleSetBeneficiaryList,
        handleSetOriginalBeneficiaryList,
        handleSetCategoryList,
        handleSetItemList,
        handleSetItemsPerCategoryList,
        handleSetPaymentTypeList,
        handleSetCurrencyList,
        handleSetStoreEmployeeList,
        handleSetCostCenterList,
        handleSetCalcTypeList,
        handleSetStoreList,
        handleSetLoading,
        handleSetIsLoaded,
        handleSetIsSalesComponent,
        handleSetHasSingleStore,
        handleSetDefaultStoreId,
        handleResetState,
    }
}